var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.4343 9.58786H20.2313V8.41162C20.2313 7.90945 19.8285 7.5 19.3323 7.5C18.8371 7.5 18.4333 7.90945 18.4333 8.41162V9.58786H17.2323C16.7361 9.58786 16.3333 9.99731 16.3333 10.4995C16.3333 11.0016 16.7361 11.4111 17.2323 11.4111H18.4333V12.5884C18.4333 13.0906 18.8371 13.5 19.3323 13.5C19.8285 13.5 20.2313 13.0906 20.2313 12.5884V11.4111H21.4343C21.9295 11.4111 22.3333 11.0016 22.3333 10.4995C22.3333 9.99731 21.9295 9.58786 21.4343 9.58786Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83331 15.0155C5.78754 15.0155 2.33331 15.6623 2.33331 18.2466C2.33331 20.8299 5.76652 21.5 9.83331 21.5C13.8781 21.5 17.3333 20.8532 17.3333 18.2689C17.3333 15.6846 13.9001 15.0155 9.83331 15.0155Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.8333 12.5542C12.5879 12.5542 14.7959 10.3177 14.7959 7.52761C14.7959 4.73754 12.5879 2.5 9.8333 2.5C7.07873 2.5 4.87067 4.73754 4.87067 7.52761C4.87067 10.3177 7.07873 12.5542 9.8333 12.5542Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.4f0aa44b6a228416ad29713cba725f75.svg";
export { ForwardRef as ReactComponent };